import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography
} from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import moment from "moment";

const Contractdetail = ({ reportdata, service, level }) => {
  const currentyear = new Date().getFullYear(); // Get the current year

  // Total number of columns depends on whether the "Hospital" column is shown.
  // level === 0  -> Hospital column shown  -> 22 columns
  // level !== 0  -> Hospital column hidden -> 21 columns
  const totalColumns = level === 0 ? 22 : 21;

  return (
    <>

      <div>
        <div style={{ padding: '20px', marginTop: '20px' }}>
          <TableContainer component={Paper} style={{ marginTop: '20px', overflow: "visible" }}>
            <div>
              <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ flexGrow: 1, marginBottom: '30px' }}>
                {/* Logo Section */}
                <Grid item style={{ marginRight: '20px' }}>
                  <img src={reportslogo} alt="logo" style={{ maxWidth: '180px', height: '180px' }} />
                </Grid>

                {/* Text Section */}
                <Grid item xs={12} md={8} style={{ textAlign: 'left', marginRight: '10px' }}>
                  {/* Title */}
                  <Typography variant="h6" style={{ margin: '0', fontSize: '30px', fontWeight: 'bold' }}>
                    Contract Master List - Details
                  </Typography>

                  {/* Hospital and Service */}
                  <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
                    <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                      {/* Hospital Master */}
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          marginRight: '20px', // Adjust space between label and value
                        }}
                      >
                        Hospital Master :
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontSize: '18px',
                          fontWeight: 'normal',
                        }}
                      >
                        {level === 0
                          ? 'All'
                          : level === 1
                            ? localStorage.getItem('FacilityName')
                            : ''}
                      </Typography>


                    </Grid>

                    <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                      {/* Service */}
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',

                          marginRight: '20px',// Adding margin between label and value
                        }}
                      >
                        Service&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontSize: '18px',

                          fontWeight: 'normal',
                        }}
                      >
                        {service.label}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                      {/* Service */}
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontSize: '18px',
                          fontWeight: 'bold',

                          marginRight: '20px',// Adding margin between label and value
                        }}
                      >
                        Year&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: '18px',
                          fontWeight: 'normal',
                        }}
                      >
                        {currentyear}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>


              <TableHead style={{ border: "1px solid black" }}>
                <TableRow >
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>No</TableCell>
                  {level === 0 && (
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        color: 'black',
                        padding: '8px',
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                      rowSpan={2}
                    >
                      Hospital
                    </TableCell>
                  )}

                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Company</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Status</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Asset Numbers</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Equipment / System Description</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Contract Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Contract Type</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Serial Number</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Model</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} colSpan={2}>
                    Period of Service Contract
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Freq PPM / Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} colSpan={7}>
                    PPM Rate / Asset (RM) Year
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Total PPM Rate Per Asset (RM)</TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }} rowSpan={2}>Total PPM Rate per Contract</TableCell>

                </TableRow>
                <TableRow >

                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>Contract Start Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>Contract End Date</TableCell>
                  {/* <TableCell align="center" sx={{ padding: '4px' }}></TableCell> */}
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>1st Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>2nd Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>3rd Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>4th Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>5th Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>6th Year</TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", color: "black", padding: '4px', border: "1px solid black", textAlign: "center", }}>7th Year</TableCell>
                  {/* <TableCell align="center" colSpan={2}></TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody style={{ border: "1px solid black" }}>
                {reportdata && reportdata.length > 0 ? (
                  reportdata
                    .filter(contract => contract.details && contract.details.length > 0)
                    .reduce((acc, contract) => acc.concat(contract.details), [])
                    .map((row, rowIndex) => {

                      return (
                        <TableRow key={rowIndex}>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{rowIndex + 1}</TableCell>
                          {level === 0 && (<TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.hospital}</TableCell>)}
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.companyName || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.status === 1 ? 'Active' : row.status === 2 ? 'Inactive' : 'Expired' || ""}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.assetNo || ''}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.equipment || ''}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.contractNo || ''}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.contractType || ''}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.serialNo || ''}</TableCell>
                          <TableCell sx={{ padding: '4px', border: "1px solid black" }}>{row.model || ''}</TableCell>
                          <TableCell align="center" sx={{ padding: '4px', border: "1px solid black" }}>
                            {row.startDate}
                          </TableCell>
                          <TableCell align="center" sx={{ padding: '4px', border: "1px solid black" }}>
                            {row.endDate}
                          </TableCell>
                          <TableCell align="center" sx={{ padding: '4px', border: "1px solid black" }}>{row.frequency || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.firstyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.secondyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.thirdyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.fourthyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.fifthyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.sixthyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.sevenyear || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.totalPPMRateAsset || ''}</TableCell>
                          <TableCell align="right" sx={{ padding: '4px', border: "1px solid black" }}>{row.totalPPMRateContract || ''}</TableCell>

                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={totalColumns} align="center" sx={{ padding: '4px', border: "1px solid black" }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>


            </div>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default Contractdetail;